{
  "CreateAccount": {
    "mainHeader": "Witaj.",
    "invitation": "{{invitedBy}} zaprosił Cię do dołączenia do tej przestrzeni roboczej"
  },
  "RegisterUserPanel": {
    "header": "Utwórz konto",
    "emailLabel": "Email",
    "passwordLabel": "Wprowadź hasło",
    "passwordPlaceholder": "Upewnij się, że jest bezpieczne",
    "confirmPasswordLabel": "Potwierdź swoje hasło",
    "confirmPasswordPlaceholder": "Wprowadź hasło",
    "continueButton": "Kontynuuj",
    "errors": {
      "passwordRequired": "Hasło jest wymagane",
      "passwordMinLength": "Hasło musi mieć co najmniej 8 znaków",
      "passwordUpperCase": "Twoje hasło powinno zawierać co najmniej 1 wielką literę",
      "confirmPasswordRequired": "Potwierdź swoje hasło",
      "passwordsMismatch": "Hasła nie pasują do siebie"
    }
  },
  "CreateProfile": {
    "header": "O Tobie",
    "subheader": "Opowiedz nam trochę o sobie, aby rozpocząć"
  },
  "CreateProfilePanel": {
    "header": "Utwórz profil",
    "firstNameLabel": "Imię",
    "firstNamePlaceholder": "Imię",
    "lastNameLabel": "Nazwisko",
    "lastNamePlaceholder": "Nazwisko",
    "continueButton": "Kontynuuj",
    "errors": {
      "firstNameRequired": "Imię jest wymagane",
      "lastNameRequired": "Nazwisko jest wymagane"
    }
  },
  "CompletedRegistration": {
    "headerWithName": "{{firstName}}, wszystko jest gotowe!",
    "header": "Wszystko jest gotowe!",
    "description": "Serdeczne pozdrowienia od Atellio. Jesteśmy platformą do zarządzania talentami, która umożliwia firmom samodzielne zarządzanie własną siecią talentów.",
    "letsGo": "Zabierz mnie tam"
  },
  "ArrivalBoard": {
    "scheduleBoard": "Tablica harmonogramu",
    "page": "Strona",
    "name": "Imię i nazwisko",
    "location": "Lokalizacja",
    "role": "Rola"
  }
}
